export default __webpack_public_path__ + "static/media/mainlogoTM.bba8532a.svg";